import { getModuleTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import moduleConfig from '../../config'

const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const NutanixHostPropertyFieldMap = () => ({
  nutanix_host_property_group: {
    title: __mtc('nutanix_host_property_group'),
    fields: [
      {
        key: generateId(),
        paramName: 'hostName',
        name: __mtc('host_name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'state',
        name: __mtc('state'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'numberOfVms',
        name: __mtc('number_of_vms'),
        inputType: 'number',
      },
      {
        key: generateId(),
        paramName: 'hostType',
        name: __mtc('host_type'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'cvmIP',
        name: __mtc('cvm_ip'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'cpuSpeed',
        name: __mtc('cpu_speed'),
        inputType: 'hertz',
      },
      {
        key: generateId(),
        paramName: 'memorySize',
        name: __mtc('memory_size'),
        inputType: 'bytes',
      },
      {
        key: generateId(),
        paramName: 'clusterUUID',
        name: __mtc('cluster_uuid'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'cpuModel',
        name: __mtc('cpu_model'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'cpuCores',
        name: __mtc('cpu_cores'),
        inputType: 'number',
      },
    ],
  },
})
